import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import SubProductCodeService from "services/Setup/Master/subProductCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  subProductCodeList: {},
};

export const getSubProductCodeList = createAsyncThunk(
  "subProductCode/getSubProductCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await SubProductCodeService.getSubProductCodeList(
        userInput
      );
      console.log('responsegetSubProductCodeList',response);
      
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
         
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const subProductCode = createSlice({
  name: "subProductCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get product code list
      .addCase(getSubProductCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSubProductCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.subProductCodeList = action.payload;
      })
      .addCase(getSubProductCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  subProductCode.actions;

export default subProductCode.reducer;
